module.exports = __webpack_public_path__ + "static/media/colleagues.d54df399.webp";